export default {
  login: '/login/login'
}
